import '../types/window';

import combinedReducer, { RootState } from '../reducers/combinedReducer';
import { configureStore, EnhancedStore } from '@reduxjs/toolkit';
import { productionEnv } from '../environment';

let store: EnhancedStore<RootState> | undefined;

// Initializes and returns the Redux store. If it's already initialized, returns the existing instance.
export function getStore(preloadedState?: Record<string, any>): EnhancedStore {
  if (!store) {
    store = configureStore({
      reducer: combinedReducer,
      preloadedState,
      middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false, // turn off checking for serializable values since we use Date in ai2fp slice.
        immutableCheck: false, // turn off immutable check since the store is HUGE and the check is slow.
      }),
      devTools: window.devToolsExtension && !productionEnv,
    });
  }
  return store;
}
